import { Flex, message, Typography, Upload } from "antd";
import { useState } from "react";
import Iconify from "./Iconify";
import Helper from "utils/Helper";

export default function CropperUpload({
  uploadRef,
  initialPreview,
  onImageChange,
}) {
  const [imagePreviewURL, setImagePreviewURL] = useState(initialPreview);
  const [imageName, setImageName] = useState("");

  const onUploadChange = async ({ file }) => {
    const isImage = Helper.allowedImageType.includes(file.type);
    if (!isImage) {
      message.error("File must be image type " +
        Helper.allowedImageType.map((type) => type.slice(6).toUpperCase()).join(", "))
      return Upload.LIST_IGNORE;
    }
    const lessThan5MB = file.size / 1024 / 1024 < 5;
    if (!lessThan5MB) {
      message.error("Image must be smaller than 5MB.")
      return Upload.LIST_IGNORE;
    }
    if (!onImageChange) {
      message.error("Image file setter function is not defined!", 1)
      return Upload.LIST_IGNORE;
    }
    setImageName(file?.name)
    setImagePreviewURL(URL.createObjectURL(file));
    onImageChange(file);
  }

  return (
    <>
      <Upload.Dragger
        ref={uploadRef}
        name="avatar"
        listType="picture"
        className="avatar-uploader"
        showUploadList={false}
        multiple={false}
        accept={Helper.allowedImageType.join(",")}
        onChange={onUploadChange}
        beforeUpload={() => false}
      >
        <button
          type='button'
          style={{
            border: "none",
            background: "none",
            padding: "12px",
            minHeight: "200px",
            width: "100%",
          }} >
          <Flex vertical align='center'>
            {imagePreviewURL ? (
              <>
                <img src={imagePreviewURL} style={{ height: "auto", maxHeight: '400px', width: "auto", maxWidth: '100%', objectFit: 'contain' }} />
              </>
            ) : (
              <>
                <Iconify icon={"mdi:tray-upload"} style={{ fontSize: "48px" }} />
                <Typography.Text style={{ display: "inline-block", marginTop: "8px" }}>
                  Click or drag here to upload image.
                </Typography.Text>
              </>
            )}

          </Flex>
        </button>
      </Upload.Dragger>
    </>
  )
}
